import React, { useRef, useLayoutEffect } from "react"

import Button from "@ui/Button"

const DangrousElement: React.FC<{markup: string}> = ({markup}) => {
	const elRef = useRef<HTMLDivElement>(null)

	useLayoutEffect(() => {
    if (!elRef.current) { return }
		const range = document.createRange()
    range.selectNode(elRef.current!)
    const documentFragment = range.createContextualFragment(markup)
    elRef.current.innerHTML = ""
    elRef.current.append(documentFragment)
	}, [markup])

	return (
		<div
			ref={elRef}
			dangerouslySetInnerHTML={{ __html: markup }} />
    )
}

const NEWSLETTER_EMBED_URL = {
  PREVIEW: "https://pc-emil-test.swmh.de/embed/index.js",
  PRODUCTION: "https://pc-emil.swmh.de/embed/index.js",
}

const XMas2020: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)

  return <div ref={ref} className="neo__extraXMas2020">
    <DangrousElement markup={`
      <script src="${NEWSLETTER_EMBED_URL.PRODUCTION}" type="module" async defer></script>
      <div data-newsletter-id="szdm-adventskalender"></div>
    `} />
    <div className="neo__extraXMas2020__linkHolder">
      <Button href="https://adventskalender.sueddeutsche.de/">Zum SZ-Adventsquiz</Button>
    </div>
  </div>
}

export default XMas2020
